// ===========================================
// "Marked by" caption text (#42 Phase 4)
// ===========================================
// Who last marked an attendance row, for STAFF only (the API never sends it to
// parents or students). `markedAt` is an INSTANT, so it is rendered in the
// SCHOOL's timezone — never with `formatUTCDate`, which is for @db.Date values
// and would show the UTC day (a mark at 08:00 Sydney on 16/09 is 22:00 UTC on
// 15/09).

import { formatInSchoolTz } from '../../utils/dateUtils';

export function markedByText(
  markedByName: string | null | undefined,
  markedAt: string | Date | null | undefined,
  timeZone: string
): string {
  if (!markedByName || !markedAt) return 'Marked by: not recorded';
  const day = formatInSchoolTz(markedAt, timeZone, { day: '2-digit', month: '2-digit', year: 'numeric' });
  return day ? `Marked by ${markedByName} · ${day}` : `Marked by ${markedByName}`;
}
